import { AbstractFirebaseManager } from './AbstractFirebaseManager';
import { trackLiveAction } from '../../../utils/tracking';

export function dispose<T>(manager: AbstractFirebaseManager<T>): void {
  const { isDisposed } = manager.context;

  if (isDisposed) {
    return;
  } else {
    trackLiveAction('fb_connection_dispose');

    manager.log.info('Disposing firebase connections');
    manager.disposeSubscribers();

    [manager.interactionApp, manager.composerApp].forEach((it, index) => {
      if (it) {
        manager.firebase?.firebase
          .deleteApp(it)
          // ! Do not access application after delete or exception will be thrown.
          // ! Use indexes for informative purposes.
          .then(() => manager.log.info('Successfully deleted app:', index))
          .catch(() => manager.log.warn('Failed to delete app:', index));
      }
    });

    /**
     * Mark actual firebase connection as stopped and not working anymore.
     */
    manager.context.isDisposed = true;
    manager.context.interactionConnection.isConnected = false;
    manager.context.composerConnection.isConnected = false;
  }
}
